import {useEffect, useRef} from 'react';
import {useDocumentChanged, useOpenDocument} from '../../../../../../views/DocumentDrawer';

export function useReloadOnDocumentDrawerChange(reload: () => void): void {
    const reloadRef = useRef(reload);
    useEffect(() => {
        reloadRef.current = reload;
    });

    const documentChanged = useDocumentChanged();
    const changeAtMount = useRef(documentChanged);
    useEffect(() => {
        if (documentChanged && documentChanged !== changeAtMount.current) {
            reloadRef.current();
        }
    }, [documentChanged]);

    const drawerOpen = useOpenDocument() !== null;
    const drawerWasOpen = useRef(drawerOpen);
    useEffect(() => {
        if (drawerWasOpen.current && !drawerOpen) {
            reloadRef.current();
        }
        drawerWasOpen.current = drawerOpen;
    }, [drawerOpen]);
}
